import { Box } from '@mui/material';
import ChangePasswordForm from 'components/login/ChangePasswordForm';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

function ChangePasswordPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <section style={{ marginBottom: '80px' }}>
      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap={2} className="pageTitleTitleContainer">
        <h2 className="pageTitle">{t('page.changePassword')}</h2>
      </Box>

      <ChangePasswordForm />
    </section>
  );
}

export default ChangePasswordPage;
